<template>
  <div class="header">
    <component :is="tag" :class="classStr"><slot></slot></component>
  </div>
</template>

<script>
export default {
  props: {
    tag: { type: String, default: () => '' },
    size: { type: String, default: () => 'm' },
    color: { type: String, default: () => 'black' }
  },

  computed: {
    classStr() {
      let classes = [];
      switch (this.size.toLowerCase()) {
        case 'l':
          classes.push('size-l');
          break;

        case 's':
          classes.push('size-s');
          break;

        case 'xs':
          classes.push('size-xs');
          break;

        case 'm':
        default:
          classes.push('size-m');
          break;
      }

      classes.push(this.color);

      return classes;
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  h2,
  h1 {
    color: #2e2e2e;
    font-style: normal;
    font-weight: 700;
    margin: 0;
    text-transform: uppercase;

    &.white {
      color: $white;
    }

    &.brown {
      color: $brown;
    }
  }

  .size-l {
    font-size: 64px;
    line-height: 118%;
    margin: 8px 0;
  }

  .size-m {
    font-size: 36px;
    line-height: 140%;
    margin: 8px 0;
  }

  .size-s {
    font-size: 22px;
    line-height: 32px;
  }

  .size-xs {
    font-size: 16px;
    line-height: 23px;
  }
}
</style>
